import Plyr from 'plyr';

import { scaleBlockToScreen } from '../helpers/video-helpers';
import scrollTo from '../helpers/scrollTo';

import { CLASSES } from '../helpers/consts';

export default () => {
	const videoWrapper = document.querySelector('.js-landing-media-wrapper');
	const videoBlock = document.querySelector('.js-landing-media-block');
	const video = document.querySelector('.js-landing-media');
	if(!video || !videoBlock) return;

	const player = new Plyr(video, {
		// ratio: '1:1',
		muted: true,
		autoplay: true,
		controls: false,
		loop: { active: true },
		// speed: {
		// 	selected: 10
		// },
		// loop: isAboutPage ? true : false
		vimeo: {
			loop: true,
			background: true,
			transparency: true,
			// autoplay: true,
			muted: true,
			playsinline: true
		}
	});
	player.on('ready', event => {
		player.muted = true;
		player.play();
		setTimeout(() => {
			videoBlock.classList.add(CLASSES.active);
		}, 400);
	});
};
